var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto my-12",staticStyle:{"margin":"20px"},attrs:{"width":"400","height":"300"}},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.tId,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }